import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageableResponse } from '@pwc-bei/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { SuggestedServiceResource } from 'src/app/models/api/suggested-service';
import { SuggestedServiceModel } from 'src/app/models/coe/suggested-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RecommendedServiceService {
  protected baseUrl: string = environment.apiUrl;
  // protected baseUrl: string = 'http://localhost:8111'
  // accorpamento esg-request
  protected endpoint: string = '/tls-fa-request/recommendedService/';

  public pagination: PageableResponse<SuggestedServiceModel[]> = {
    pageable: {
      pageNumber: 0,
      pageSize: 5,
      offset: 0,
      sort: '',
    },
    number: null,
    size: null,
    totalElements: null,
    numberOfElements: null,
    content: null,
  };

  constructor(private httpClient: HttpClient) {}

  convertModelToResource(
    model: SuggestedServiceModel,
  ): SuggestedServiceResource {
    return { ...model };
  }

  convertResourceToModel(
    resource: SuggestedServiceResource,
  ): SuggestedServiceModel {
    return {
      id: resource.id,
      serviceId: resource.serviceId,
      customerId: resource.customerId,
      societyId: resource.societyId,
      title: resource.title,
      status: resource.status,
      area: resource.area,
      code: resource.code,
      isRecommended: resource.isRecommended,
      image: resource.image,
    };
  }

  findAll(
    customerId: string,
    societyId: number,
    sort?: string,
    page?: number,
    pageSize?: number,
    searchTerm?: string,
    terms?: string[],
    isPaged?: boolean,
    recommendedOnly?: boolean,
    title?: string,
    selectedServices?: string[],
    withImg?: boolean,
  ): Observable<any> {
    let params: HttpParams = new HttpParams();

    // Pagination: if present update the saved pagination; use the saved pagination otherwise
    if (page != undefined) {
      this.pagination.pageable.pageNumber = page;
      params = params.append('page', page.toString());
    } else {
      params = params.append(
        'page',
        this.pagination.pageable.pageNumber
          ? this.pagination.pageable.pageNumber.toString()
          : '0',
      );
    }

    if (pageSize) {
      this.pagination.pageable.pageSize = pageSize;
      params = params.append('size', pageSize.toString());
    } else {
      params = params.append(
        'size',
        this.pagination.pageable.pageSize
          ? this.pagination.pageable.pageSize.toString()
          : '10',
      );
    }

    /* if (sort && sort !== '') {
      this.pagination.pageable.sort = sort;
      params = params.append('sort', sort);
    } else if (this.pagination.pageable.sort != '') {
      params = params.append('sort', this.pagination.pageable.sort);
    } */

    // SerchTerm
    if (searchTerm && searchTerm !== '') {
      params = params.append('searchTerm', searchTerm);
      terms.forEach((term) => {
        params = params.append('terms', term);
      });
    }

    if (recommendedOnly) {
      params = params.append('recommendedOnly', 'true');
    }

    if (title) {
      params = params.append('title', title);
    }

    if (isPaged != undefined) {
      params = params.append('isPaged', isPaged ? 'true' : 'false');
    }

    if (withImg != undefined) {
      params = params.append('withImg', withImg ? 'true' : 'false');
    }

    if (selectedServices) {
      selectedServices.forEach((term) => {
        params = params.append('selectedServices', term);
      });
    }

    // Execute the API call and return the body of the response
    return this.httpClient
      .get<PageableResponse<SuggestedServiceModel[]>>(
      this.baseUrl +
          this.endpoint +
          'customer/' +
          customerId +
          '/society/' +
          societyId +
          '/',
      {
        params,
        observe: 'response',
      },
    )
      .pipe(map((res) => res.body))
      .pipe(
        map((res) => {
          if (!(res instanceof Array)) {
            this.pagination.totalElements = res.totalElements;
            this.pagination.number = res.number;
            this.pagination.size = res.size;
            this.pagination.numberOfElements = res.numberOfElements;
            this.pagination.pageable = res.pageable;
          }
          return res;
        }),
      );
  }
}
